<template>
  <div v-if="featureToggle.MEMBERSHIP" class="personal-container" v-loading="display.isLoading">
    <!-- current signed in member section -->
    <div class="personal-info section" v-if="currentCustomer">
      <div class="centre">Hello {{ currentCustomer.firstName }} {{ currentCustomer.surname }}</div>
      <el-row :gutter="10">
        <el-col :span="12" class="right">
          <strong>Points</strong>
        </el-col>
        <el-col :span="12">{{ totalPoints }}</el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12" class="right">
          <strong>Phone</strong>
        </el-col>
        <el-col :span="12">{{ currentCustomer.phone }}</el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12" class="right">
          <strong>Signed Up</strong>
        </el-col>
        <el-col :span="12">{{ currentCustomer.createdTimeDisplay }}</el-col>
      </el-row>
    </div>

    <hr v-if="currentCustomer" />

    <!-- Menus -->
    <el-row v-if="currentCustomer" :gutter="8" class="centre personal-menus section">
      <el-col :span="8">
        <el-card class="box-card bg-gold">
          <div slot="header" class="clearfix" @click="onClickOrders">
            <div class="title black">Orders</div>
          </div>
          <div @click="onClickOrders">
            <i class="el-icon-s-order icon"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card bg-gold">
          <div slot="header" class="clearfix" @click="onClickReservations">
            <div class="title black">Reservations</div>
          </div>
          <div @click="onClickReservations">
            <i class="el-icon-watch icon"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card bg-gold">
          <div slot="header" class="clearfix" @click="onClickPoints">
            <div class="title black">Points</div>
          </div>
          <div @click="onClickPoints">
            <i class="el-icon-trophy-1 icon"></i>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <hr v-if="currentCustomer" />

    <div class="section">
      <div class="sub-section">
        <el-button class="full-width bg-gold black" @click="onClickBack">Back</el-button>
      </div>
      <div class="sub-section" v-if="currentCustomer">
        <el-button class="full-width bg-black gold" @click="onClickSignOut">Sign Out</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { featureToggle } from "@/utils";
import logger from "@/utils/logger";
import { getMe, getTotalPoints } from "@/api/customer";

const name = "Personal";
const log = logger(name);

export default {
  data() {
    return {
      featureToggle,
      currentCustomer: null,

      totalPoints: 0,

      display: {
        isLoading: true
      }
    };
  },
  computed: {
    ...mapGetters(["token", "customerId"])
  },
  async created() {
    if (!featureToggle.MEMBERSHIP) {
      log.info("Membership not enabled");
      return this.$router.back();
    }
    log.info("Created", this.token, this.customerId);
    if (this.token) {
      const [currentCustomer, totalPoints] = await Promise.all([
        getMe(),
        getTotalPoints()
      ]);
      log.info("Current customer", currentCustomer);
      log.info("Total points", totalPoints);
      this._decorateCustomer(currentCustomer);
      this.currentCustomer = currentCustomer;
      this.totalPoints = totalPoints.toFixed(1);
    }
    this.display.isLoading = false;
  },
  methods: {
    onClickOrders() {
      log.info("Clicked orders");
      this.$router.push("/orders");
    },
    onClickReservations() {
      log.info("Clicked reservations");
      this.$router.push("/reservations");
    },
    onClickPoints() {
      log.info("Clicked points");
      this.$router.push("/points");
    },

    onClickBack() {
      log.info("Clicked back");
      this.$router.back();
    },
    async onClickSignOut() {
      log.info("Clicked sign out");
      this.display.isLoading = true;
      await this.$store.dispatch("customer/signOut");
      this.$router.replace("/");
    },

    _decorateCustomer(customer) {
      customer.createdTimeDisplay = moment(customer.createdTime).format(
        "D MMM YYYY"
      );
    }
  }
};
</script>

<style scoped>
.section {
  padding: 0.5rem;
  margin: 1rem 0;
}

.sub-section {
  margin-bottom: 0.5rem;
}

.personal-info h4 {
  margin: 0;
}

.personal-menus .box-card .title {
  font-size: 0.8rem;
}

.personal-menus .box-card .icon {
  font-size: 1.6rem;
}
</style>